import { useIsMobile } from "@/hooks/use-mobile";
import SelectMatchesDesktopDialog from "./SelectMatchesDesktopDialog";
import SelectMatchesMobileSheet from "./SelectMatchesMobileSheet";

interface SelectMatchesDialogButtonProps {
    selectedMatchIds?: number[];
    onMatchSelect?: (matchIds: number[]) => void;
    useExternalState?: boolean;
}

export default function SelectMatchesDialogButton(props: SelectMatchesDialogButtonProps = {}) {
    const isMobile = useIsMobile();

    if (isMobile) {
        return <SelectMatchesMobileSheet {...props} />;
    }

    return <SelectMatchesDesktopDialog {...props} />;
}
